import { bmwTheme, miniTheme } from './themes';

export const totalQuota = ({ dashboard }) => dashboard.totalQuota;
export const inCart = ({ dashboard }) => dashboard.inCart;
export const webShopCloseTime = ({ dashboard }) => dashboard.closingTime;
export const productionPeriod = ({ dashboard }) => dashboard.productionPeriod;
export const stale = ({ dashboard }) => dashboard.stale;
export const dealerName = ({ dashboard }) => dashboard.dealerName;
export const mini = ({ dashboard }) => dashboard.brand === 'MI';
export const theme = ({ dashboard }) =>
  dashboard.brand === 'MI' ? miniTheme : bmwTheme;
export const currentBrand = ({ dashboard }) => dashboard.brand;
export const addDisclaimer = ({ dashboard }) => {
  return dashboard.brand === 'MI' && dashboard.productType === '1';
};
